module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/goals-live-longer.json
// module id = 372
// module chunks = 213636032000838